import { jsx as _jsx } from "react/jsx-runtime";
import { getConfig, getOauthClientId, isConfigSet } from '@local/app-config';
import { trackError } from '@local/metrics/dist/src/metrics';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/GridLegacy';
import { useContext, useEffect } from 'react';
import { clearCombinedToken as clearAccessToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { clearCSRFState } from '../../store/sessionStorageHelpers/authStateHelpers';
import { clearDeeplink } from '../../store/sessionStorageHelpers/deeplinkHelper/deeplinkHelper';
import { clearEntitlements } from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { LoginContext } from '../loginHandler/LoginContext';
function handleRedirect(url) {
    window.location.href = url;
}
function buildLogoutUrl(forceOauthPrefix) {
    let baseUrl = '';
    if (isConfigSet()) {
        const config = getConfig();
        baseUrl = config.identity_url;
    }
    if (baseUrl.length > 0) {
        const logoutCallback = `${window.location.origin}/login`;
        const oauthConsumerKey = getOauthClientId(forceOauthPrefix);
        const logoutUrl = new URL(`${baseUrl}/logout`);
        const query = logoutUrl.searchParams || new URLSearchParams();
        query.append('oauthConsumerKey', oauthConsumerKey);
        query.append('logoutCallback', logoutCallback);
        logoutUrl.search = query.toString();
        return logoutUrl;
    }
    return undefined;
}
export function Logout() {
    const { forceOauthPrefix } = useContext(LoginContext);
    useEffect(() => {
        clearAccessToken();
        clearEntitlements();
        clearDeeplink();
        clearCSRFState();
        const logoutUrl = buildLogoutUrl(forceOauthPrefix);
        if (!logoutUrl) {
            trackError('Error getting config to buildLogoutUrl');
            window.location.reload();
            return;
        }
        handleRedirect(logoutUrl.href);
    }, []);
    return (_jsx(Grid, { container: true, direction: "column", alignItems: "center", justifyContent: "center", style: { minHeight: '100vh' }, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(CircularProgress, {}) }) }));
}
//# sourceMappingURL=Logout.js.map